var map = {
	"./animais.svg": "IUHC",
	"./ciencia-e-tecnologia.svg": "Vbwf",
	"./coronavirus.svg": "mRa/",
	"./cultura.svg": "oVx3",
	"./drogas.svg": "bnUI",
	"./economia.svg": "L1Z+",
	"./educacao.svg": "M6Ed",
	"./esporte.svg": "FELA",
	"./internacional.svg": "KWpD",
	"./lgbt.svg": "QEW4",
	"./meio-ambiente.svg": "FPU0",
	"./mulheres.svg": "8Vlt",
	"./negritude.svg": "03KH",
	"./pcd.svg": "re+x",
	"./politica-urbana.svg": "+Pgt",
	"./saude.svg": "v/9z",
	"./seguranca-alimentar.svg": "LNGl",
	"./seguranca.svg": "rbMW"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rnQt";